import { ENTERPRISE as EnterpriseProductLevel, FREE, PROFESSIONAL, STARTER as StarterProductLevel } from 'self-service-api/constants/ProductLevels';
export const STARTER = 'starter';
export const ENTERPRISE = 'enterprise';
export const orderedTabs = [ENTERPRISE, STARTER];
export const tabIdToProductLevels = {
  [STARTER]: [FREE, StarterProductLevel],
  [ENTERPRISE]: [PROFESSIONAL, EnterpriseProductLevel]
};